import { Events } from '~/web-frontend-core/utils//enums/kafka';
import { searchEvent } from '~/web-frontend-core/utils/KafkaLogger/SearchEvent';
import ClientAxios from '~/web-frontend-core/clientAxios';
import ImprintHash from '~/web-frontend-core/utils/getImprintHash';
import { getConfig } from '~/web-frontend-core/config';
import Qs from 'qs';
/**
  В режиме разработки, логи на стенд не отправляются.
  Если нужно отследить логирование, нужно задать куку debug : 'LOG'.
 */
export class KafkaLogger {
    constructor() {
        this.pageNotFound = null;
        this.additionalData = {};
        this.baseUrl = (getConfig('IS_TEST') || getConfig('IS_DEV') || getConfig('TYPE') === 'cupis' || this.isIrmProject()) ? getConfig('API_URL') : 'https://statscollect.com';
        this.KafkaRequests = new ClientAxios(this.baseUrl);
        this.KafkaImprintHash = ImprintHash.getInstance();
        this.setAdditionalData = (additionalData = {}) => {
            additionalData.imprintHash = this.KafkaImprintHash.getImprintHash();
            for (const key in additionalData) {
                if (additionalData[key]) {
                    this.additionalData[key] = additionalData[key];
                }
                else {
                    delete this.additionalData[key];
                }
            }
        };
        this.setPageNotFound = (page = null) => {
            this.pageNotFound = page;
        };
        this.getPageNotFound = () => {
            return this.pageNotFound;
        };
        this.listenerBrowserTabClose = () => {
            if (getConfig('IS_SERVER')) {
                return;
            }
            const sendCloseLogs = () => {
                const detail = { sourceScreen: window.is404 ? '404' : window.location.pathname };
                this.sendLogUseBeaconApi(Events.tabClosed, detail);
            };
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') {
                    sendCloseLogs();
                }
            });
            window.addEventListener('pagehide', sendCloseLogs);
        };
        this.sendLog = (eventName, detail) => {
            if (this.pageNotFound && eventName === Events.topMoved) {
                detail.sourceScreen = this.pageNotFound;
            }
            const data = searchEvent(eventName, detail, this.additionalData);
            if (!data) {
                return;
            }
            this.KafkaRequests.post('/ajax/kafka/log', data);
        };
        this.sendLogUseBeaconApi = (eventName, detail) => {
            if (this.pageNotFound && eventName === Events.topMoved) {
                detail.sourceScreen = this.pageNotFound;
            }
            const data = searchEvent(eventName, detail, this.additionalData);
            if (!data) {
                return false;
            }
            const stringifyData = Qs.stringify(data);
            const blob = new Blob([stringifyData], {
                type: "application/x-www-form-urlencoded",
            });
            const result = navigator.sendBeacon(`${this.baseUrl}/ajax/kafka/log`, blob);
            return result;
        };
        this.listenerBrowserTabClose();
    }
    isIrmProject() {
        var _a;
        try {
            if (!process.env.PROJECT)
                return false;
            const projectConfig = JSON.parse(String(process.env.PROJECT));
            return ((_a = projectConfig === null || projectConfig === void 0 ? void 0 : projectConfig.main) === null || _a === void 0 ? void 0 : _a.appName) === 'IRM';
        }
        catch (error) {
            console.error('Error parsing process.env.PROJECT:', error);
            return false;
        }
    }
    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new KafkaLogger();
        return this.instance;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/KafkaLogger/KafkaLogger.js